import './contactPage.scss';
import template from './contactPage.html';
import { contactPageController as controller } from './contactPage.controller';

export var contactPageComponent = {
  template,
  controller
};